/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreOrderingStatusRequest } from '../../models/store-ordering-status-request';

export interface UpdateStoreOrderingStatus$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  action: 'activate' | 'deactivate' | 'cancel-deactivation';
      body: StoreOrderingStatusRequest
}

export function updateStoreOrderingStatus(http: HttpClient, rootUrl: string, params: UpdateStoreOrderingStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateStoreOrderingStatus.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('action', params.action, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateStoreOrderingStatus.PATH = '/stores/{storeId}/ordering-status/{action}';
